module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_goldberg_sm-d6e8153aa475d59de75998326707f356.png";